export default {
  // 获取问卷详情
  getQuestionnaireDetail: '/amc/client/getQuestionnaireDetail',
  // 获取问卷详情 H5
  getQuestionnaireDetailForH5: '/amc/client/getQuestionnaireDetailForH5',
  // 获取多主体
  getMainbodyList: '/amc/client/getMainbodyList',
  // 获取调查问卷需要显示的自定义字段
  getCustomMemberFields: '/amc/client/getCustomMemberFields',
  // 获取问卷题目
  getQuestionnaireSubjects: '/amc/client/getQuestionnaireSubjects',
  // 保存答卷
  addQuestionAnswer: '/amc/client/addQuestionAnswer'
}